import * as ReselectModule from "reselect";
import { IClientDemandListState } from ".";
import { IApplicationState } from "..";

export const selectClientDemandList: ReselectModule.Selector<
  IApplicationState,
  IClientDemandListState
> = (state) => state.clientDemandList;
